module.exports = __webpack_public_path__ + "static/media/avanzado.43923ddd.jpg";